import { ArrowRight, Brain, Repeat2, Stars, Zap } from 'lucide-react';
import React from 'react';
import { motion } from 'framer-motion';
import { OcdCycleCircle } from './OcdCycleCircle';
import { OcdCycleCompassElement } from './OcdCycleCompassElement';
import { OllieBlockingCycle } from './OllieBlockingCycle';
import { containerVariants, arcVariants, elementVariants, ollieVariants, ollieTextVariants, arrowVariants } from './OcdCycleVariants';

interface OcdCycleProps {
    currentStep: number;
    children: React.ReactNode;
    className?: string;
}

export const OcdCycle = ({ currentStep, children, className }: OcdCycleProps) => {

    const maxStep = Object.keys(containerVariants).length - 1;
    // Ensure we don't exceed available steps
    const safeStep = Math.max(0, Math.min(currentStep, maxStep));
    const currentStepKey = `step${safeStep}`;

    return (
        // needed for positioning
        <div className={`flex flex-col items-center justify-center ${className}`}>
            <div
                className="relative"
                style={{
                    width: '120vw',
                    height: '120vw',
                    maxWidth: '650px',
                    maxHeight: '650px'
                }}
            >
                <motion.div
                    className="absolute inset-0"
                    variants={containerVariants}
                    animate={currentStepKey}
                >
                    <OcdCycleCircle
                        arcVariants={arcVariants}
                        currentStep={currentStepKey}
                    />

                    <OcdCycleCompassElement
                        position="north"
                        label="obsession"
                        variants={elementVariants.north}
                        currentStep={currentStepKey}
                    >
                        <Brain />
                    </OcdCycleCompassElement>

                    <OcdCycleCompassElement
                        position="south"
                        label="compulsion"
                        variants={elementVariants.south}
                        currentStep={currentStepKey}
                    >
                        <Repeat2 />
                    </OcdCycleCompassElement>

                    <OcdCycleCompassElement
                        position="east"
                        label="anxiety"
                        variants={elementVariants.east}
                        currentStep={currentStepKey}
                    >
                        <Zap />
                    </OcdCycleCompassElement>

                    <OcdCycleCompassElement
                        position="west"
                        label="relief"
                        variants={elementVariants.west}
                        currentStep={currentStepKey}
                    >
                        <Stars />
                    </OcdCycleCompassElement>
                </motion.div>
                <motion.div
                    className='absolute top-[55px] left-1/2 -translate-x-1/2 -translate-y-1/2'
                    variants={arrowVariants}
                    animate={currentStepKey}>
                    <ArrowRight />
                </motion.div>

                <OllieBlockingCycle
                    variants={ollieVariants}
                    textVariants={ollieTextVariants}
                    currentStep={currentStepKey}
                />
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center z-10">
                    {children}
                </div>
            </div>
        </div>
    );
};
